const en = {
  // App
  appName: 'NanoImage2',
  appSlogan: 'Type a sentence, generate art instantly',

  // BottomNav
  nav_home: 'Home',
  nav_generate: 'Create',
  nav_profile: 'Profile',

  // Home
  home_hotTemplates: 'Popular Templates',
  home_slideMore: 'Slide for more',
  home_showcase: 'Featured Works',
  home_aiGenerated: 'AI Generated',
  home_newUserBenefit: 'New User Bonus',
  home_login: 'Sign In',
  home_openMembership: 'Get Premium',
  home_vipActive: 'VIP',
  home_vip: 'VIP',
  home_aiCardDesc: 'Multiple styles · HD watermark-free',
  home_activityTemplates: 'Featured Activities',
  home_recentWorks: 'Recent Works',
  home_viewMore: 'View More',
  home_templateCategories: 'Template Categories',
  home_noRecentWorks: 'No recent works',

  // Generate
  gen_title: 'AI Create',
  gen_describeScene: 'Describe your scene',
  gen_placeholder: 'Describe what you want to create, e.g.: A young woman in a hanfu dress standing under cherry blossoms, petals falling, dreamy glow...',
  gen_clear: 'Clear',
  gen_reference: 'Reference',
  gen_template: 'Template',
  gen_style: 'Style',
  gen_ratio: 'Ratio',
  gen_aiHelp: 'AI Write',
  gen_generate: 'Generate Now',
  gen_generating: 'Generating...',
  gen_pointsCost: '{{cost}} credits per generation',
  gen_pointsCostThisTime: 'Cost',
  gen_pointsLeft: 'Remaining',
  gen_points: 'credits',
  gen_aiCreating: 'AI is creating...',
  gen_aiCreatingDesc: 'Drawing your unique scene based on your description...',
  gen_highQuality: 'Generating high-quality image, please wait...',
  gen_result: 'Result',
  gen_success: 'Success',
  gen_inspiration: 'Inspiration',
  gen_selectStyle: 'Select Style',
  gen_selectTemplate: 'Select Template',
  gen_selectRatio: 'Select Ratio',
  gen_vipUnlock: 'Upgrade to unlock all styles',
  gen_sdDownload: 'Standard',
  gen_hdDownload: 'HD Download',
  gen_regenerate: 'Regenerate',
  gen_promptLabel: 'Prompt',
  gen_hdNeedVip: 'HD Download Requires Premium',
  gen_hdNeedVipDesc: 'Upgrade to Premium to download HD watermark-free images and enjoy more exclusive benefits.',
  gen_cancel: 'Cancel',
  gen_openMembership: 'Get Premium',
  gen_firstGenTitle: 'Generated!',
  gen_firstGenDesc: 'Your first AI artwork is born',
  gen_firstGenBenefits: 'Upgrade for more benefits',
  gen_benefit1: 'Unlimited HD downloads',
  gen_benefit2: 'Exclusive VIP styles',
  gen_benefit3: '10 AI writes per day',
  gen_benefit4: 'Priority generation',
  gen_continue: 'Continue',
  gen_retry: 'Retry',
  gen_generationCancelled: 'Generation cancelled',
  gen_pointsInsufficient: 'Insufficient Credits',
  gen_pointsInsufficientDesc: 'Each generation costs {{cost}} credits. Your balance is insufficient. Upgrade to Premium for unlimited generations!',
  gen_uploadReference: 'Upload Reference',
  gen_referenceDesc: 'Upload a reference image for AI to follow its style',
  gen_removeReference: 'Remove',
  gen_aiHelpExhausted: 'AI write limit reached',
  gen_aiHelpFailed: 'AI write failed, please try again',
  gen_contentViolation: 'Content violation, please revise your description',
  gen_saveSuccess: 'Saved to album',
  gen_genFailed: 'Generation failed, please retry',
  gen_capacityFullMessage: '{{active}}/{{limit}} images are generating. Submit again when one finishes.',
  gen_capacityIndicator: '{{active}}/{{limit}} tasks',
  gen_capacityNotSubmitted: 'Not submitted: generation capacity is full. Try again when a task finishes.',
  gen_submitNotAccepted: 'The task was not submitted. Check the request and try again.',
  gen_pricingConfigUpdated: 'Credit pricing was updated. Review the latest cost and submit again.',
  gen_pricingConfigRefreshFailed: 'Credit pricing could not be refreshed. Nothing was submitted; try again later.',
  gen_submissionConfirming: 'Confirming whether the task was submitted. Do not send it again.',
  gen_genTimeout: 'Generation timed out, please retry',
  gen_referenceUploadFailed: 'Reference upload failed, please retry',
  gen_referenceTooLarge: 'Image too large, please choose a smaller one',
  gen_useTemplate: 'Use Template',
  gen_loginTitle: 'Sign in to start creating',
  gen_loginDesc: 'Sign in to use AI generation, save history\nand enjoy premium benefits',
  gen_loginBtn: 'Sign In',

  // Phase 2 — model & quality selector
  gen_model: 'Model',
  gen_modelLabel: 'Select Model',
  gen_quality: 'Quality',
  gen_quality_standard: 'Standard',
  gen_quality_hd: 'HD',
  gen_quality_ultra: 'Ultra HD',
  gen_quality_ultraVipOnly: 'Ultra HD is VIP-only',
  gen_quality_ultraVipDesc: 'Upgrade to Premium to unlock Ultra HD generation',
  gen_quality_ultraVipBtn: 'Upgrade VIP',
  gen_recommended: 'Top Pick',
  gen_model_cost: '{{cost}} credits',
  gen_pixels: 'px',

  // Quality selector names and descriptions
  gen_quality_standard_name: 'Standard',
  gen_quality_standard_desc: 'Standard clarity, fast generation',
  gen_quality_hd_name: 'HD Quality',
  gen_quality_hd_desc: 'Higher clarity, richer details',
  gen_quality_ultra_name: 'Ultra HD',
  gen_quality_ultra_desc: 'Maximum clarity, extreme detail (VIP only)',

  // Phase 2 — recent usage modal
  gen_recentTitle: 'Recent Uses',
  gen_noRecent: 'No recent history',
  gen_clickToRefill: 'Tap to fill parameters',

  // Phase 2 — 8-state task status
  gen_status_created: 'Task created',
  gen_status_queued: 'Queued...',
  gen_status_generating: 'AI creating...',
  gen_status_auditing: 'Reviewing content...',
  gen_status_success: 'Done',
  gen_status_failed: 'Generation failed',
  gen_status_blocked: 'Content blocked',
  gen_status_timeout: 'Timed out',
  gen_status_cancelled: 'Cancelled',
  gen_status_refunded: 'Refunded',

  // Phase 2 — reason codes
  gen_reason_TXT_RISK_BLOCKED: 'Your prompt contains restricted content. Please revise and retry.',
  gen_reason_REF_RISK_BLOCKED: 'Reference image contains restricted content. Please replace it.',
  gen_reason_IMG_RISK_BLOCKED: 'Generated image was blocked by content policy.',
  gen_reason_TASK_CREATE_FAILED: 'Task creation failed. Please try again.',
  gen_reason_QUEUE_TIMEOUT: 'Queue timed out. Please try again later.',
  gen_reason_MODEL_ERROR: 'AI model error. Please try again later.',
  gen_reason_AUDIT_TIMEOUT: 'Content review timed out. Please try again.',
  gen_reason_AUDIT_ERROR: 'Review service error. Please try again.',
  gen_reason_COMPENSATED_CLOSED: 'Credits refunded due to error. Please retry.',
  gen_reason_REFERENCE_IMAGE_DOWNLOAD_FAILED: 'Reference image could not be read. Please upload it again and retry.',
  gen_reason_PROVIDER_BAD_REQUEST: 'The AI model could not process this request. Please adjust the prompt or image.',
  gen_reason_PROVIDER_RATE_LIMITED: 'The AI model is busy or rate limited. Please try again later.',
  gen_reason_PROVIDER_ERROR: 'AI generation service is temporarily unavailable. Please try again later.',
  gen_reason_PROVIDER_TIMEOUT: 'AI generation timed out. Please try again later.',
  gen_reason_PROVIDER_CAPACITY: 'The AI service is busy. Credits were refunded; please resubmit later.',
  gen_reason_PROVIDER_TEXT_POLICY_REJECTED: 'The prompt was blocked by content policy. Please edit it and retry.',
  gen_reason_PROVIDER_SAFETY_BLOCKED: 'The input or output image was blocked by content policy. Credits were refunded.',
  gen_reason_PROVIDER_AUTH_FAILED: 'The AI service is misconfigured. Credits were refunded; please try later.',
  gen_reason_PROVIDER_INVALID_REQUEST: 'This request could not be processed. Credits were refunded; please adjust it.',
  gen_reason_PROVIDER_OUTCOME_UNKNOWN: 'The provider result is being reconciled. Please do not submit it again.',
  gen_reason_OUTPUT_STORAGE_FAILED: 'The image could not be stored. Credits were refunded; please resubmit.',
  gen_reason_OUTPUT_QUALITY_FAILED: 'The image failed quality checks. Credits were refunded; please resubmit.',
  gen_reason_TASK_TIMEOUT: 'The task timed out. Credits were refunded; please resubmit.',
  gen_reason_RULE_BLOCKED: 'The prompt was blocked by content rules. Please edit it and retry.',
  gen_reason_SAFE_001: 'Safety review is temporarily unavailable. Credits were refunded; please try later.',
  gen_reason_SAFE_002: 'This image cannot be reviewed. Please replace it and retry.',
  gen_reason_GENERATION_FAILED: 'Generation failed. Please try again later.',
  gen_reason_CONFIG_ERROR: 'Generation configuration error. Please contact support.',
  gen_reason_default: 'Please try again later.',

  gen_modifyPrompt: 'Edit Prompt',
  gen_tryAgain: 'Retry',
  result_nextTitle: 'Keep creating',
  result_nextDesc: 'Save this result, then refine it or generate more options.',
  result_addedHistory: 'In history',
  result_continueEdit: 'Continue editing',
  result_regenerateFour: 'Regenerate 4',
  result_changeStyle: 'Change style',
  result_addFavorite: 'Favorite',
  result_favorited: 'Favorited',

  // Tool guidance
  tool_before: 'Before',
  tool_after: 'After',
  tool_inputRequirement: 'Input requirement',
  tool_expectedResult: 'Expected result',
  tool_ifFails: 'If it looks wrong',

  // Profile
  profile_title: 'Profile',
  profile_loginTitle: 'Sign in to view your profile',
  profile_loginDesc: 'Sign in to check credits, membership\nand generation history',
  profile_loginBtn: 'Sign In',
  profile_menu: 'My Account',
  profile_history: 'History',
  profile_points: 'Credits',
  profile_currentPoints: 'Current',
  profile_membership: 'Membership',
  profile_membershipDesc: 'Unlock more benefits',
  profile_vipMember: 'VIP Member',
  profile_settings: 'Settings',
  profile_contact: 'Support',
  profile_agreement: 'Terms of Service',
  profile_privacy: 'Privacy Policy',
  profile_version: 'NanoImage2 v1.0.0',
  profile_pointsBalance: 'Credits',
  profile_generateTimes: 'Generations',
  profile_historyCount: 'History',
  profile_openMembership: 'Get Premium',
  profile_favorites: 'Favorites',
  profile_noFavorites: 'No favorites yet',
  profile_noFavoritesDesc: 'Tap the star on any work to save it here',
  profile_noHistory: 'No generation history yet',
  profile_noHistoryDesc: 'Try AI image generation now',
  profile_goGenerate: 'Create Now',
  profile_continueCreating: 'Continue Creating',
  profile_regenerate: 'Regenerate',
  profile_pointsTitle: 'Credits Info',
  profile_pointsLog: 'Credit History',
  profile_contactTitle: 'Contact Support',
  profile_emailService: 'Email Support',
  profile_phoneService: 'Phone Support',
  profile_loading: 'Loading...',
  profile_loadMore: 'Load More',

  // Profile Edit
  profile_edit_title: 'Edit Profile',
  profile_edit_avatar: 'Avatar',
  profile_edit_tapToChange: 'Tap to change avatar',
  profile_edit_nickname: 'Nickname',
  profile_edit_nicknamePlaceholder: 'Enter nickname (1-20 chars)',
  profile_edit_save: 'Save',
  profile_edit_saving: 'Saving…',
  profile_edit_saveSuccess: 'Saved',
  profile_edit_saveFail: 'Save failed, please retry',
  profile_edit_avatarUploadFail: 'Avatar upload failed, please retry',

  // Membership header & VIP view
  member_headerDesc: 'HD Generation · Premium Styles · Priority Queue',
  member_remainPoints: 'Points Left',
  member_remainDays: 'Days Left',
  member_autoRenew: 'Auto',
  member_cancelledRenew: 'Cancelled',
  member_renewing: 'Renewing',
  member_notRenewing: 'No Renew',
  member_unlockedBenefits: 'Unlocked Benefits',
  member_monthlyUsage: 'Monthly Usage',
  member_unlimited: 'Unlimited',
  member_renewPlan: 'Renew Plan',
  member_selectedPlanBenefits: 'Selected Plan Benefits',
  member_firstPurchaseGift: '{{points}} credits on first purchase',
  member_purchaseGift: '{{points}} credits with purchase',
  member_valueTitle: 'How credits and VIP work',
  member_valueDesc: 'Credits pay for each generation; VIP unlocks a better creation experience.',
  member_valueFreeTitle: 'Free trial',
  member_valueFreeDesc: 'Use bonus credits to try core features first.',
  member_valueCreditsTitle: 'Credit cost',
  member_valueCreditsDesc: 'Each tool consumes credits by use, with failure handling by policy.',
  member_valueVipTitle: 'VIP benefits',
  member_valueVipDesc: 'HD watermark-free output, priority queue, premium styles, and bonus credits.',

  // Membership
  member_title: 'Get Premium',
  member_subtitle: 'Unlock all AI generation benefits',
  member_currentPoints: 'Credits: ',
  member_benefits: 'Premium Benefits',
  member_selectPlan: 'Choose a Plan',
  member_perMonth: '/mo',
  member_giftPoints: '+',
  member_giftPointsUnit: ' credits',
  member_selected: 'Selected',
  member_openNow: 'Subscribe Now',
  member_agreePrefix: 'By subscribing you agree to',
  member_memberAgreement: 'Terms of Service',
  member_and: 'and',
  member_autoRenewAgreement: 'Auto-Renewal Terms',
  member_successTitle: 'Subscribed!',
  member_successPlan: 'Plan:',
  member_successPlanSuffix: '',
  member_successPoints: 'Bonus',
  member_successPointsSuffix: 'credits added',
  member_startCreate: 'Start Creating',
  member_agreeBtn: 'I Agree',
  member_vipStatus: 'GlowPic VIP',
  member_vipExpire: 'Valid until',
  member_vipActive: 'Active',
  member_manageSub: 'Manage Subscription',
  member_manageUnavailable: 'Apple subscription management is temporarily unavailable. Try again later.',
  member_renew: 'Renew Membership',
  member_cancelAutoRenew: 'Cancel Auto-Renewal',
  member_cancelConfirm: 'Cancel Auto-Renewal?',
  member_cancelDesc: 'Your benefits remain valid until end of current period. No further renewals.',
  member_cancelBtn: 'Confirm Cancel',
  member_enableAutoRenew: 'Enable Auto-Renewal',
  member_keepRenew: 'Maybe Later',
  member_hdUnlocked: 'HD Downloads Unlocked',
  member_styleUnlocked: 'All Styles Unlocked',
  member_priorityUnlocked: 'Priority Queue Unlocked',
  member_processing: 'Processing…',
  member_restorePurchases: 'Restore Purchases',
  member_restoringPurchases: 'Restoring…',
  member_restoreSuccess: 'Purchases restored',
  member_restoreNone: 'No purchases were found to restore.',
  member_restorePartial: 'Some purchases were restored. Please try again later for the remaining items.',
  member_restoreFailed: 'Unable to restore purchases. Please try again later.',
  member_syncAppStore: 'Sync with App Store',
  member_syncAppStoreHint: 'Still missing a purchase? Syncing may require Apple account verification, but it will not create a new charge.',
  member_packagesLoading: 'Loading plans…',
  member_packagesLoadFailed: 'Unable to load plans. Check your connection and try again.',
  member_storePriceLoading: 'Loading App Store prices…',
  member_storePriceFailed: 'App Store prices are unavailable. Purchases are temporarily disabled.',
  member_retry: 'Reload',
  member_storeProductUnavailable: 'This product is temporarily unavailable. Please try again later.',
  member_payFailed: 'Payment failed, confirming order status…',
  member_payCancelled: 'Purchase cancelled. You were not charged.',
  member_payPendingApple: 'Waiting for Apple approval. Your membership will recover automatically.',
  member_payConfirming: 'Your purchase may be complete. Confirming benefits; please do not buy again.',
  member_paySuccessMsg: 'Payment successful! Welcome to Premium',
  member_payIncomplete: 'Payment incomplete, please retry',
  member_payRepairing: 'Payment received. Your benefits are being activated or repaired automatically.',
  member_payPendingRecovery: 'Your previous order is still being confirmed. Please wait before purchasing again.',
  member_cancelFailed: 'Failed to cancel, please retry',
  member_enableAutoRenewSuccess: 'Auto-renewal enabled',
  member_enableAutoRenewFail: 'Failed to enable auto-renewal, please retry',
  member_activeTitle: 'Membership Active',
  member_expireAt: 'Expires: ',
  vipNotice_title: 'Membership notice',
  vipNotice_fixed_term_expiring: 'Your membership expires in {{days}} days (valid through {{date}}).',
  vipNotice_auto_renew_scheduled: 'Apple is expected to renew your subscription on {{renewalDate}}.',
  vipNotice_auto_renew_disabled_expiring: 'Auto-renew is off. Your membership expires in {{days}} days.',
  vipNotice_billing_retry: 'Apple is retrying the renewal. Check your payment method to avoid interruption.',
  vipNotice_grace: 'Renewal has not completed. You are in the grace period; check your Apple payment method.',
  vipNotice_expired: 'Your membership has expired and standard account benefits now apply.',
  vipNotice_none: '',
  vipNotice_viewMembership: 'View membership',
  vipNotice_dismiss: 'Dismiss for today',
  member_autoRenewLabel: '· Auto-renews',
  member_recommended: 'Recommended',
  member_loginTitle: 'Sign in to view membership',
  member_loginDesc: 'Sign in to check benefits, credits\nand subscribe to premium plans',
  member_loginBtn: 'Sign In',
  member_perYear: '/yr',
  member_perQuarter: '/qtr',
  member_onlyPerDay: 'Only {{currency}}{{price}}/day',
  member_save: 'Save {{currency}}{{amount}}',
  member_neverExpires: 'Never Expires',
  member_daysUnit: ' days',
  member_renewAction: 'Renew',
  member_exclusiveBenefits: 'Exclusive Benefits',

  // Settings
  settings_title: 'Settings',
  settings_account: 'Account',
  settings_accountSecurity: 'Account & Security',
  settings_notifications: 'Notifications',
  settings_general: 'General',
  settings_clearCache: 'Clear Cache',
  settings_language: 'Language',
  settings_about: 'About',
  settings_agreement: 'Terms of Service',
  settings_privacy: 'Privacy Policy',
  settings_aboutUs: 'About Us',
  settings_rateUs: 'Rate Us',
  settings_logout: 'Sign Out',
  settings_logoutConfirm: 'Sign out of your account?',
  settings_logoutDesc: 'You will need to sign in again to use AI generation.',
  settings_logoutConfirmBtn: 'Sign Out',
  settings_cancel: 'Cancel',
  settings_clearCacheTitle: 'Clear Cache',
  settings_clearCacheDesc: 'This will clear',
  settings_clearCacheDesc2: 'of cached data. Your account data will not be affected.',
  settings_clearCacheConfirm: 'Clear',
  settings_clearCacheSuccess: 'Cache Cleared',
  settings_clearCacheSuccessDesc: '12.3 MB of space freed',
  settings_cacheFreedDesc: '{{size}} of space freed',
  settings_aboutTitle: 'About Us',
  settings_version: 'Version v1.0.0',
  settings_aboutDesc: 'NanoImage2 is an AI image generation app. Built around three input modes — text prompts, reference images, and style templates — it pairs multi-model routing with quality tiers to turn a creative intent into a re-generatable image. We continuously refine prompt expansion, model routing, and output quality, focusing on bringing each description closer to the picture you have in mind.',
  settings_copyright: '© 2026 NanoImage2. All rights reserved.',
  settings_phone: 'Phone',
  settings_email: 'Email',
  settings_cancelSubSuccess: 'Cancellation request submitted. Please go to iOS Settings > Apple ID > Subscriptions to disable auto-renewal.',
  settings_operateFailed: 'Operation failed, please try again',
  settings_cacheCalculating: 'Calculating...',
  settings_cacheLessThan1MB: '< 1 MB',
  profile_changeAvatar: 'Change Avatar',
  profile_chooseFromAlbum: 'Choose from Album',
  profile_takePhoto: 'Take Photo',
  profile_supportHours: '7×24 Support Available',
  gen_referenceUploaded: 'Reference uploaded',
  profile_workTime: 'Mon-Fri 10:00 - 18:00',
  settings_verified: 'Verified',
  settings_loading: 'Loading…',
  settings_loginAccount: 'Login account',
  settings_primaryLogin: 'Primary login',
  settings_loginImmutableHint: 'Your login method cannot be switched and is never automatically merged with another phone, email, Google, or Apple account.',
  settings_contactInfo: 'Contact information',
  settings_contactNotLoginHint: 'Bound phone numbers and emails are contact details only. They cannot sign in to this account.',
  settings_notBound: 'Not bound',
  settings_bindContact: 'Bind',
  settings_changeContact: 'Change',
  settings_removeContact: 'Remove',
  settings_contactRemoveConfirm: 'Remove this contact detail? Your login account will not change.',
  settings_bindPhone: 'Bind phone',
  settings_bindEmail: 'Bind email',
  settings_phonePlaceholder: 'Phone number',
  settings_emailPlaceholder: 'Email address',
  settings_codePlaceholder: 'Verification code',
  settings_sendCode: 'Send code',
  settings_resendCode: 'Resend',
  settings_confirmBind: 'Confirm',
  settings_providerPhone: 'Phone verification code',
  settings_providerEmail: 'Email verification code',
  settings_securityLoadFailed: 'Unable to load account security',
  settings_securityOperationFailed: 'Operation failed. Please try again.',
  settings_deleteFailed: 'Account deletion failed. Your account and local session were not changed. Please try again.',
  settings_deleteAccount: 'Delete Account',
  settings_deleteAccountTitle: 'Delete Account',
  settings_deleteAccountDesc: 'The following data will be permanently deleted:',
  settings_deleteItem1: 'Account info and credentials',
  settings_deleteItem2: 'All generation history',
  settings_deleteItem3: 'Credits and membership benefits',
  settings_deleteWarning: 'This action cannot be undone. Please proceed carefully.',
  settings_continueDelete: 'Continue',
  settings_confirmDelete: 'Confirm Delete',
  settings_confirmDeleteTitle: 'Confirm Deletion',
  settings_confirmDeleteDesc: 'Type "delete account" to confirm',
  settings_confirmDeletePlaceholder: 'delete account',
  settings_back: 'Back',
  settings_notifyGenerateDone: 'Generation Complete',
  settings_notifyGenerateDoneDesc: 'Notify when image generation is done',
  settings_notifyActivity: 'Promotions',
  settings_notifyActivityDesc: 'Deals, new features and updates',
  settings_notifySystem: 'System Messages',
  settings_notifySystemDesc: 'Account security and maintenance notices',
  settings_languageTitle: 'Language',
  settings_currentLang: 'Current',
  settings_langZh: '简体中文',
  settings_langEn: 'English',
  settings_rateTitle: 'Rate Us',
  settings_rateDesc: 'Your feedback helps us improve',
  settings_rateSubmit: 'Submit',
  settings_rateThanks: 'Thank You!',
  settings_rateThanksDesc: 'Your feedback means a lot to us',
  settings_footerText: 'NanoImage2 v1.0.0',
  settings_simplifiedChinese: '简体中文',
  settings_comingSoon: 'Coming soon',
  settings_langOnlyChinese: 'More languages coming soon',
  settings_loginTitle: 'Sign in to view settings',
  settings_loginDesc: 'Sign in to manage your account, notifications\nand personalized features',
  settings_loginBtn: 'Sign In',

  // Templates
  template_exampleCount: '{{count}} examples',
  tpl_female_portrait: 'Female Portrait',
  tpl_male_portrait: 'Male Portrait',
  tpl_anime_avatar: 'Anime Avatar',
  tpl_chinese_portrait: 'Chinese Style',
  tpl_poster: 'Poster Design',

  // Styles
  sty_ccd: 'CCD Camera',
  sty_film: 'Film Style',
  sty_chinese: 'Chinese Ink',
  sty_3d_cartoon: '3D Cartoon',
  sty_comic: 'Comic',
  sty_dunhuang: 'Dunhuang Art',

  // Inspiration hints
  insp_female_portrait: 'Female Portrait',
  insp_female_portrait_sub: 'Elegant · Soft Light',
  insp_chinese_portrait: 'Chinese Style',
  insp_chinese_portrait_sub: 'Hanfu · Ink Art',
  insp_anime_avatar: 'Anime Avatar',
  insp_anime_avatar_sub: '2D · Kawaii',
  insp_poster: 'Creative Poster',
  insp_poster_sub: 'Gradient · Bold Visual',

  // Showcase labels
  showcase_ccd: 'CCD Camera',
  showcase_anime: 'Anime Avatar',
  showcase_chinese: 'Chinese Style',
  showcase_3d: '3D Cartoon',
  showcase_film: 'Film Style',
  showcase_poster: 'Poster Design',
  showcase_comic: 'Comic',

  // Membership benefits
  benefit_hd_title: 'HD Watermark-Free',
  benefit_hd_desc: 'Download HD images without watermarks',
  benefit_more_title: 'More Generations',
  benefit_more_desc: 'Monthly bonus credits for unlimited creation',
  benefit_style_title: 'Unlock Premium Styles',
  benefit_style_desc: 'Access all exclusive styles including Dunhuang Art',
  benefit_speed_title: 'Priority Generation',
  benefit_speed_desc: 'Priority queue for faster results',

  // Membership packages
  pkg_monthly_auto_name: 'Monthly Auto',
  pkg_monthly_auto_desc: 'Auto-renews, cancel anytime',
  pkg_monthly_auto_tag: 'Best Value',
  pkg_monthly_auto_feature: 'HD · Exclusive Styles · 10 AI Writes/Day · Priority',
  pkg_monthly_name: 'Monthly',
  pkg_monthly_desc: 'One-time purchase, valid 30 days',
  pkg_monthly_feature: 'HD · Exclusive Styles · Priority Generation',

  // New user gift
  newUserGift_desc: 'Sign up and get {{giftPoints}} free credits — up to {{maxImages}} images',

  // Points rules
  points_rule_register: 'Sign Up Bonus',
  points_rule_dailyLogin: 'Daily Login',
  points_rule_generate: 'Per Generation',

  // Points log descriptions
  pointsLog_generate: 'AI Generation',
  pointsLog_dailyLogin: 'Daily Login Bonus',
  pointsLog_register: 'New User Bonus',
  pointsLog_refundGenFail: 'Generation Refund',
  pointsLog_vipGift: 'VIP Bonus Credits',
  pointsLog_promptExpandCost: 'AI Write Cost',

  // Login (English: email default)
  login_title: 'NanoImage2',
  login_subtitle: 'AI Image Generator',
  login_slogan1: 'Type a sentence,',
  login_slogan2: 'generate art instantly',
  login_emailLabel: 'Email',
  login_emailPlaceholder: 'Enter your email address',
  login_emailCodeLabel: 'Verification Code',
  login_emailCodePlaceholder: 'Enter 6-digit code',
  login_sendEmailCode: 'Send Code',
  login_sending: 'Sending...',
  login_resend: 'Resend',
  login_agreePrefix: 'By signing in, you agree to the',
  login_userAgreement: 'Terms of Service',
  login_and: 'and',
  login_privacyPolicy: 'Privacy Policy',
  login_emailLoginBtn: 'Sign In / Register',
  login_loggingIn: 'Signing in...',
  login_loginSuccess: 'Sign In',
  login_emailFooterDesc: 'New email will automatically create an account. ',
  login_errEmail: 'Please enter a valid email address',
  login_errEmailCode: 'Please enter the 6-digit code',
  login_errAgree: 'Please agree to the Terms of Service',
  login_phoneLabel: 'Phone',
  login_phonePlaceholder: 'Enter phone number',
  login_codeLabel: 'Code',
  login_codePlaceholder: 'Enter verification code',
  login_sendCode: 'Send Code',
  login_switchEmail: 'Sign in with Email',
  login_switchPhone: 'Sign in with Phone',
  login_loginBtn: 'Sign In / Register',
  login_footerDesc: 'New phone number will automatically create an account. ',
  login_errPhone: 'Please enter a valid phone number',
  login_errCode: 'Please enter the 6-digit code',
  login_errSmsFail: 'SMS service unavailable, please try again later',
  login_errSendFail: 'Send failed, please try again',
  login_errLoginFail: 'Login failed, please try again',
  login_errChallenge: 'Please request a verification code first',
  login_errProviderUnavailable: 'This sign-in method is temporarily unavailable',
  login_or: 'or',
  login_google: 'Continue with Google',
  login_apple: 'Continue with Apple',
  login_socialLoading: 'Signing in...',
  login_independentAccounts: 'Each sign-in method creates a separate account and data is not shared.',

  // Profile edit entry
  profile_editProfile: 'Edit Profile',
  profile_changeNickname: 'Change Nickname',

  // Generate — ConfigBar
  gen_creationSettings: 'Creation',
  gen_outputSettings: 'Output',
  gen_referenceShort: 'Reference',
  gen_styleShort: 'Style',
  gen_templateShort: 'Template',
  gen_modelFallback: 'Model',
  gen_modelShort: 'Model',
  gen_noAvailableModels: 'No model available',
  gen_ratioFallback: 'Ratio',
  gen_qualityFallback: 'Quality',
  gen_noAvailableQualities: 'No quality available',
  gen_countFallback: 'Count',
  gen_countSingle: 'Single',
  gen_selectedConfig: 'Config',
  gen_seeMore: 'More',
  gen_notAdded: 'None',
  gen_notSelected: 'Not set',
  gen_standardQuality: 'Standard',
  gen_qualityHd: 'HD',
  gen_qualityUltra: 'Ultra',
  gen_recentUsage: 'Recent',
  gen_noTemplates: 'No templates',
  gen_all: 'All',
  gen_estimateTime: 'Est. ~30s',
  reference_image_alt: 'Reference image',

  // VIP upgrade sheet
  vip_unlock_ultra_title: 'Unlock VIP',
  vip_unlock_ultra_desc: 'Upgrade to enjoy all premium features',
  vip_unlock_benefit1: 'Unlock HD/Ultra quality',
  vip_unlock_benefit2: 'Unlock VIP-exclusive styles',
  vip_open_now: 'Upgrade Now',
  vip_not_now: 'Not Now',

  // Share sheet
  share_moments: 'Moments',
  share_wechat: 'WeChat',
  share_copyLink: 'Copy Link',
  share_saveImage: 'Save Image',
  share_cancel: 'Cancel',
  share_linkCopied: 'Link copied',
  gen_saving: 'Saving...',
  gen_savedToAlbum: 'Saved to Photos',
  gen_saveFailed: 'Save failed, please retry',

  // Profile — preview modal actions
  profile_reuseParams: 'Reuse Params',
  profile_collect: 'Collect',
  profile_favorited: 'Favorited',
  profile_share: 'Share',
  profile_save: 'Save',
  profile_delete: 'Delete',
  profile_deleteConfirm: 'Delete this image?',
  profile_deleteFailed: 'Delete failed, please retry',
  profile_promptCopied: 'Copied',

  // BottomNav — gallery tab (v2.0)
  nav_gallery: 'Gallery',

  // Gallery page (v2.0)
  gallery_title: 'Gallery',
  gallery_filter_all: 'All',
  gallery_filter_text2img: 'Text to Image',
  gallery_filter_img2img: 'Image to Image',
  gallery_filter_edit: 'Edit Image',
  gallery_filter_restore: 'HD Restore',
  gallery_filter_tryon: 'Model Try-On',
  gallery_totalWorks: 'Works',
  gallery_hotToday: 'Hot Today',
  gallery_empty: 'No works yet',
  gallery_loadMoreHint: 'Loading more community creations...',
  gallery_loading: 'Loading...',
  gallery_loadMore: 'Load More',
  gallery_noMore: 'All works loaded',
  gallery_featured: 'Featured',
  gallery_usePrompt: 'Use Prompt',
  gallery_similarCreate: 'Create Similar',

  // Home — v2.0 new sections
  home_aiTools: 'AI Creation Tools',
  home_heroTitle: 'Unleash Your Imagination',
  home_heroSubtitle: 'AI-powered all-in-one image creation platform',
  home_startCreate: 'Start Creating',
  home_exploreMore: 'Explore More',
  home_todayGenerated: 'Generated Today',
  home_onlineCreators: 'Creating Now',
  home_totalWorks: 'Total Works',
  home_inspirationBanner: 'Inspiration Gallery',
  home_inspirationBannerDesc: 'Explore the boundless imagination of community creators',
  home_enterGallery: 'Enter Gallery',
  home_featuredWorks: 'Featured Works',
  home_modelEntry_title: 'Trending Models',
  home_modelEntry_new: 'New',
  home_nanoBanana_desc: 'Fast creative generation · Instant inspiration',
  home_chatgptImage_desc: 'Realistic & precise · Powered by GPT',

  // Home — AI tool cards (v2.0)
  tool_text2img: 'Text to Image',
  tool_text2img_desc: 'Describe it, AI creates from scratch',
  tool_img2img: 'Image to Image',
  tool_img2img_desc: 'Upload reference, create based on it',
  tool_edit: 'Edit & Retouch',
  tool_edit_desc: 'Upload image, describe changes',
  tool_restore: 'Quality Restore',
  tool_restore_desc: 'One-click HD for blurry photos',
  tool_tryon: 'Model Try-On',
  tool_tryon_desc: 'Person + clothing for model shots',
  tool_more: 'More',
  tool_hot: 'Hot',

  // Generate — mode selector (v2.0)
  mode_text2img: 'Text to Image',
  mode_img2img: 'Image to Image',
  mode_edit: 'Edit Image',
  mode_restore: 'HD Restore',
  mode_tryon: 'Model Try-On',

  // Generate — gen_mode aliases (v2.0)
  gen_mode_text2img: 'Text to Image',
  gen_mode_img2img: 'Image to Image',
  gen_mode_edit: 'Edit Image',
  gen_mode_restore: 'HD Restore',
  gen_mode_tryon: 'Model Try-On',

  // Generate — img2img / upload labels (v2.0)
  img2img_uploadReference: 'Upload Reference Images',
  img2img_clickUpload: 'Tap to upload references',
  img2img_supportFormat: 'JPG and PNG only. Up to 6 images',
  img2img_referenceCount: '{{count}}/{{max}} reference images added',
  img2img_addMore: 'Add more',
  img2img_imageLimit: 'You can upload up to {{count}} reference images',
  img2img_onlyJpgPng: 'Image to Image only supports JPG and PNG images',
  img2img_describeChange: 'Describe the changes you want',
  img2img_placeholder: 'Describe what you want based on the reference, e.g. change background to seaside sunset...',

  // Generate — required field marker
  gen_required: 'Required',

  // Generate — chat interface (v2.0)
  chat_regenerating: 'Regenerating...',
  chat_generationPendingTip: 'Your image is being generated. You can also view it later in My generation history.',
  chat_recentMemoryTitle: 'Showing your 3 latest creations',
  chat_recentMemoryDesc: 'View every image in My generation history',
  chat_viewAllHistory: 'View all',
  chat_insp1: 'Cyberpunk style girl',
  chat_insp2: 'Chinese ink landscape',
  chat_insp3: 'Cute chibi anime character',
  chat_insp4: 'Futuristic sci-fi city',
  chat_insp5: 'Japanese healing illustration',
  chat_insp6: 'Dreamy starry sky scene',
  chat_welcomeCardTitle: 'Hi! I am AI Artist',
  chat_welcomeCardLine1: 'Tell me the scene you want,',
  chat_welcomeCardLine2: 'I\'ll create a stunning artwork for you',
  chat_aiAssistant: 'AI Artist',
  chat_editPlaceholder: 'Describe how to edit these images, e.g. replace the background with a seaside sunset while keeping the person',
  chat_defaultEditPrompt: 'Create and edit based on the uploaded images',
  chat_imageLimit: 'You can upload up to {{count}} reference images',
  chat_voiceStart: 'Voice input',
  chat_voiceStop: 'Stop voice input',
  chat_voiceListening: 'Listening...',
  chat_voiceListeningWithText: 'Recognizing: {{text}}',
  chat_voiceUnsupported: 'Voice input is not supported in this environment',
  chat_voicePermissionDenied: 'Please allow microphone access and try again',
  chat_voiceNoSpeech: 'No speech detected. Please try again',
  chat_voiceFailed: 'Voice recognition failed. Please try again',
  chat_voiceLang: 'en-US',
  profile_filterStatusAll: 'All',
  profile_filterStatusActive: 'In progress',
  profile_filterStatusSuccess: 'Success',
  profile_filterStatusIncomplete: 'Incomplete',
  profile_filterButton: 'Filter',
  profile_filterTitle: 'Filter generation history',
  profile_filterClose: 'Close filters',
  profile_filterModel: 'Model',
  profile_filterAllModels: 'All models',
  profile_filterPeriod: 'Time',
  profile_filterAllTime: 'All time',
  profile_filterToday: 'Today',
  profile_filter7Days: 'Last 7 days',
  profile_filter30Days: 'Last 30 days',
  profile_filterOrder: 'Sort',
  profile_filterNewest: 'Newest first',
  profile_filterOldest: 'Oldest first',
  profile_filterReset: 'Reset',
  profile_filterViewResults: 'View results',
  profile_filterLoadFailed: 'Could not load generation history',
  profile_filterLoadFailedDesc: 'Check your connection and try again',
  profile_filterRetry: 'Reload',
  profile_filterNoMatches: 'No generations match these filters',
  profile_filterNoMatchesDesc: 'Try changing or clearing your filters',
  profile_filterClear: 'Clear filters',
  gen_refreshInspiration: 'Refresh',
  gen_placeholderWithExample: 'Describe the scene you want in detail\ne.g. A young woman in hanfu standing under cherry blossoms, petals falling, dreamy light, ultra-high quality',

  // More AI Tools page (v2.0)
  extool_title: 'More AI Tools',
  extool_subtitle: 'Discover more powerful AI image processing features to unleash your creativity',
  extool_comingSoon: 'Coming Soon',
  extool_bgReplace: 'BG Replace',
  extool_bgReplace_desc: 'Smart subject detection, one-click background replacement',
  extool_bgClean: 'Background Cleanup',
  extool_bgClean_desc: 'Remove cluttered background elements for a cleaner look',
  extool_clothExtract: 'Clothing Extract',
  extool_clothExtract_desc: 'Precisely extract clothing items from photos',
  extool_outpaint: 'AI Outpainting',
  extool_outpaint_desc: 'Intelligently expand image borders and fill content',
  extool_watermarkRemove: 'Watermark Removal',
  extool_watermarkRemove_desc: 'AI-powered watermark and object removal',
  extool_colorize: 'Photo Colorize',
  extool_colorize_desc: 'Intelligently colorize black and white photos',
  extool_objectRemove: 'Object Removal',
  extool_objectRemove_desc: 'Remove unwanted people or objects from photos',
  extool_styleTransfer: 'Style Transfer',
  extool_styleTransfer_desc: 'Transform images into any artistic style',

  // Tool pages — bg-replace (v2.0)
  bg_replace_uploadLabel: 'Upload Image',
  bg_replace_uploadPlaceholder: 'Tap to upload image',
  bg_replace_promptLabel: 'New Background',
  bg_replace_promptPlaceholder: 'Describe your desired background, e.g. cherry blossom park, seaside sunset, city night...',
  bg_replace_promptTip: 'More detailed description gives better results',
  bg_replace_inputRequirement: 'Upload a clear image with a complete subject. Avoid heavy occlusion around people or products.',
  bg_replace_expectedResult: 'AI keeps the subject, replaces the background with your scene, and tries to match lighting.',
  bg_replace_fallbackTip: 'If subject edges look rough, use a cleaner original image or describe the target background more specifically.',
  bg_replace_beforeHint: 'Original bg',
  bg_replace_afterHint: 'New bg',

  // Tool pages — bg-clean (v2.0)
  bg_clean_uploadLabel: 'Upload Image',
  bg_clean_uploadPlaceholder: 'Tap to upload image',
  bg_clean_defaultPrompt: 'Background cleanup',

  // Tool pages — cloth-extract (v2.0)
  cloth_extract_sourceLabel: 'Upload Garment Source',
  cloth_extract_sourcePlaceholder: 'Tap to upload a garment source image',
  cloth_extract_defaultPrompt: 'Clothing extraction',
  cloth_extract_inputRequirement: 'Upload one image with a clear, complete, minimally occluded garment.',
  cloth_extract_expectedResult: 'AI extracts one garment into a centered 1:1 standalone image.',
  cloth_extract_fallbackTip: 'If the outline is incomplete, use a cleaner source with the whole garment visible.',
  cloth_extract_beforeHint: 'Garment source',
  cloth_extract_afterHint: 'Standalone garment',

  // Tool pages — outpaint (v2.0)
  outpaint_uploadLabel: 'Upload Image',
  outpaint_uploadPlaceholder: 'Tap to upload image',
  outpaint_directionLabel: 'Select Expansion Direction',
  outpaint_top: 'Up',
  outpaint_bottom: 'Down',
  outpaint_left: 'Left',
  outpaint_right: 'Right',
  outpaint_defaultPrompt: 'AI outpainting',

  // Tool pages — watermark-remove (v2.0)
  watermark_remove_uploadLabel: 'Upload Image',
  watermark_remove_uploadPlaceholder: 'Tap to upload image',
  watermark_remove_defaultPrompt: 'Watermark removal',
  watermark_remove_inputRequirement: 'Upload an image where the watermark is visible and the main subject remains complete.',
  watermark_remove_expectedResult: 'AI reconstructs the covered area so the background and texture blend naturally.',
  watermark_remove_fallbackTip: 'If repair marks remain, crop closer to the watermark area or process smaller regions step by step.',
  watermark_remove_beforeHint: 'Watermarked',
  watermark_remove_afterHint: 'Clean image',

  // Tool pages — colorize (v2.0)
  colorize_uploadLabel: 'Upload Old Photo',
  colorize_uploadPlaceholder: 'Tap to upload old photo',
  colorize_strengthLabel: 'Colorization Strength',
  colorize_gentle: 'Natural',
  colorize_strong: 'Vivid',
  colorize_currentStrength: 'Current',
  colorize_defaultPrompt: 'Photo colorization',

  // Tool pages — object-remove (v2.0)
  object_remove_uploadLabel: 'Upload Image',
  object_remove_uploadPlaceholder: 'Tap to upload image',
  object_remove_descLabel: 'Describe to Remove',
  object_remove_descPlaceholder: 'Describe what to remove, e.g. person at bottom left, car in background...',
  object_remove_descTip: 'More specific description gives better results',
  object_remove_defaultPrompt: 'Object removal',

  // Tool pages — style-transfer (v2.0)
  style_transfer_uploadLabel: 'Upload Image',
  style_transfer_uploadPlaceholder: 'Tap to upload image',
  style_transfer_styleLabel: 'Select Art Style',
  style_transfer_defaultPrompt: 'Style transfer',

  // Generate — edit mode labels
  edit_uploadOriginal: 'Upload Original Image',
  edit_tapToMarkArea: 'Uploaded. Describe what to change.',
  edit_clickUpload: 'Tap to upload original image',
  edit_supportFormat: 'JPG and PNG images supported',
  edit_describeEdit: 'Describe the edit',
  edit_placeholder: 'Describe what to change, e.g. swap background with cherry blossoms...',
  edit_aiSuggestion: 'AI Suggestion',
  restore_uploadImage: 'Upload Photo',
  restore_previewMode: 'Uploaded. HD restoration will be applied.',
  restore_clickUpload: 'Tap to upload photo',
  restore_supportFormat: 'JPG and PNG images supported',
  restore_strength: 'Restoration Strength',
  restore_gentle: 'Gentle',
  restore_strong: 'Strong',
  tryon_uploadPerson: 'Upload Person Photo',
  tryon_uploadClothing: 'Upload Clothing Photo',
  tryon_personTip: 'Upload a clear front-facing photo',
  tryon_clothingTip: 'Upload a full garment photo',
  tryon_selectPose: 'Select Pose',
  tryon_pose_natural: 'Natural',
  tryon_pose_front: 'Front',
  tryon_pose_side: 'Side',
  tryon_pose_cross: 'Arms Crossed',
};

export default en;
export type I18nDict = typeof en;
